import { render, staticRenderFns } from "./Personaltransaction.vue?vue&type=template&id=303d4fc6&scoped=true&"
import script from "./Personaltransaction.vue?vue&type=script&lang=js&"
export * from "./Personaltransaction.vue?vue&type=script&lang=js&"
import style0 from "./Personaltransaction.vue?vue&type=style&index=0&id=303d4fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303d4fc6",
  null
  
)

export default component.exports